import { memo } from "react";
import { ReloadIcon } from "vega-icons";
import { SomethingwentwrongIllustration } from "vega-illustrations";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { Panel } from "@vega-core/components/Layout/Panel";
import { NumberedList } from "@vega-core/components/NumberedList/NumberedList";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  background?: string;
  title?: string;
  description?: string;
  variant?: "default" | "info";
};

export const DefaultErrorPanel = memo(
  ({ background, title, description, variant = "default" }: Props) => {
    const {
      contacts: { helpEmail = "" },
    } = usePublicConfig();

    const errorListItems = [
      {
        id: "1",
        title: m.errorPanel_troubleshoot_step1Title(),
        description: m.errorPanel_troubleshoot_step1Description(),
      },
      {
        id: "2",
        title: m.errorPanel_troubleshoot_step2Title(),
        description: m.errorPanel_troubleshoot_step2Description(),
      },
      {
        id: "3",
        title: m.errorPanel_troubleshoot_step3Title(),
        description: m.errorPanel_troubleshoot_step3Description(),
      },
    ];

    if (variant === "default") {
      return (
        <Panel
          customBackground={background}
          description={description ?? m.common_defaultDataError()}
          title={title}
        />
      );
    }

    return (
      <Panel
        customBackground={background}
        description={description ?? m.common_defaultDataError()}
        icon={<SomethingwentwrongIllustration />}
        title={title}
      >
        <NumberedList items={errorListItems} />
        <div className="mt-6 flex flex-col items-center justify-center gap-6">
          <ThemedButton
            dataTestId="error-panel-refresh-button"
            icon={<ReloadIcon />}
            onClick={() => location.reload()}
          >
            {m.btn_refreshPage()}
          </ThemedButton>

          <ThemedButton
            dataTestId="error-panel-contact-button"
            route={`mailto:${helpEmail}`}
            variant="text"
          >
            {m.btn_contactSupport()}
          </ThemedButton>
        </div>
      </Panel>
    );
  },
);
